/**
 * 인증 만료/미인증 에러 판별.
 *
 * QueryProvider 는 이 에러에서 재시도를 멈추고 로그인으로 보내고, 텔레메트리는
 * 정상 흐름(세션 만료)으로 보고 에러 지표에서 뺀다.
 */
export function isAuthError(error: unknown): boolean {
  if (!(error instanceof Error)) return false
  const msg = error.message.toLowerCase()
  return (
    msg.includes('인증이 필요합니다') ||
    msg.includes('인증 정보') ||
    msg.includes('unauthorized') ||
    msg.includes('authentication required')
  )
}
